// extracted by mini-css-extract-plugin
module.exports = {"grid":"CheckboxGroup_grid__5cWSp","row":"CheckboxGroup_row__3L4Pr"};